import { render, staticRenderFns } from "./CanvasScrollyVideo.vue?vue&type=template&id=6a64cac2&"
import script from "./CanvasScrollyVideo.vue?vue&type=script&lang=js&"
export * from "./CanvasScrollyVideo.vue?vue&type=script&lang=js&"
import style0 from "./CanvasScrollyVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports